import { Controller, useFormContext } from "react-hook-form";
import { useState, type FC } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { AppInput } from "@/shared/Components";
import { LockIcon } from "@/shared/icons";
import { VisibilityControlButton } from "@/shared/Components/Buttons";
import type { InputProps } from "antd/lib";
import { InputError } from "../../InputError";
import styles from "./styles.module.scss";

export const FormInputPassword: FC<InputProps> = ({ name = "", ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);
  const visibleHandler = () => setIsShowPassword((prev) => !prev);
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, ref } }) => (
        <div className={styles["input-container"]}>
          <AppInput
            ref={ref}
            type={isShowPassword ? "text" : "password"}
            value={value}
            prefix={<LockIcon />}
            className={styles["input-password"]}
            onChange={onChange}
            status={errors[name] ? "error" : ""}
            suffix={<VisibilityControlButton onClick={visibleHandler} isVisible={isShowPassword} />}
            {...props}
          />
          <div className={styles["input-error"]}>
            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => {
                return <InputError message={message} />;
              }}
            />
          </div>
        </div>
      )}
    />
  );
};
